import { render } from "./IRRRegularHeatmap.vue?vue&type=template&id=1cb6d9ad"
import script from "./IRRRegularHeatmap.vue?vue&type=script&lang=js"
export * from "./IRRRegularHeatmap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__